import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import PageTypography from "src/components/PageTypography/PageTypography";
import PageButton from "src/components/PageButton";

interface CommonDialogProps {
  open: boolean;
  title?: string;
  content?: React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  hideActions?: boolean;
  loading?:boolean
}

const CommonDialog: React.FC<CommonDialogProps> = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  confirmText ,
  cancelText ,
  hideActions = false,
  loading = false
}) => {

  
  const { t } = useTranslation();

    const resolvedConfirmText = confirmText ?? t("OK");
  const resolvedCancelText = cancelText ?? t("Cancel");


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent>
        {typeof content === "string" ? (
          <PageTypography>{content}</PageTypography>
        ) : (
          content
        )}
      </DialogContent>

      {!hideActions && (
        <DialogActions>
          <PageButton variant="outlined" sx={{marginLeft:"8px"}} onClick={onClose}>{resolvedCancelText}</PageButton>
          {onConfirm && (
            <PageButton loading={loading} variant="contained" onClick={onConfirm}>
              {resolvedConfirmText}
            </PageButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CommonDialog;

